import { AxiosDelete, AxiosGet, AxiosPost } from "../useApi";


export function GetSchedules() {
    const route = 'schedules';
    return AxiosGet(route);
}

export function GetScheduleById(scheduleId) {
    const route = 'schedules/by-id/';
    return AxiosGet(route, scheduleId);
}

export function CreateSchedule(data) {
    const route = 'schedules/create';
    return AxiosPost(route, null, data)
}

export function UpdateSchedule(params, data) { 
    const route = 'schedules/update';
    return AxiosPost(route, params, data);
}

export function DeleteSchedule(id) { 
    const route = 'schedules/delete';
    return AxiosDelete(route, null, { id });
}